﻿/**
* DevExpress Analytics (query-builder\wizard\pageFactory.js)
* Version:  21.2.8
* Build date: Jun 7, 2022
* Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PageFactory = (function () {
    function PageFactory() {
        this.metadata = {};
    }
    PageFactory.prototype.registerMetadata = function (pageId, metadata) {
        if (!metadata.canFinish)
            metadata.canFinish = function (page) { return page.canFinish(); };
        if (!metadata.canNext)
            metadata.canNext = function (page) { return page.canNext(); };
        this.metadata[pageId] = metadata;
    };
    PageFactory.prototype.getMetadata = function (pageId) {
        return this.metadata[pageId];
    };
    PageFactory.prototype.unregisterMetadata = function (pageId) {
        delete this.metadata[pageId];
    };
    PageFactory.prototype.reset = function () {
        this.metadata = {};
    };
    return PageFactory;
}());
exports.PageFactory = PageFactory;
